var React = require('react');

function Cerrar (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0H1200V800H0z","transform":"translate(-25 -375)","key":0}),React.createElement("g",{"fill":"#fff","key":1},[React.createElement("path",{"d":"M23.971 1.971H25.971V47.971000000000004H23.971z","transform":"translate(-25 -375) translate(25 375) rotate(45 24.97 24.97)","key":0}),React.createElement("path",{"d":"M23.971 1.971H25.971V47.971000000000004H23.971z","transform":"translate(-25 -375) translate(25 375) rotate(-45 24.97 24.97)","key":1})])]));
}

Cerrar.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = Cerrar;

Cerrar.default = Cerrar;
